module.exports = __webpack_public_path__ + "static/media/paypal.cb02527a.svg";